var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noa-notes-widget"},[(_vm.loading && !_vm.widgetInitialized)?_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"loading loading-lg"}),_c('p',{staticClass:"mt-2"},[_vm._v("Inicializando Noa Notes...")])]):_vm._e(),_c('div',{attrs:{"id":"noa-widget-container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }